import { useQueryParams } from '@plato/ui-legacy/lib/hooks/use-query-params';
import { queryParamsConfig, stringParam } from '@plato/ui-legacy/lib/query-params';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const queryConfig = queryParamsConfig({
    task_id: stringParam(),
});

export function TaskDialogListener() {
    const [queryParams] = useQueryParams(queryConfig, {
        task_id: '',
    });

    const navigate = useNavigate();

    useEffect(() => {
        if (queryParams.task_id) {
            void navigate(`/tasks?d_task_id=${queryParams.task_id}`, { replace: true });
        }
    }, [queryParams.task_id, navigate]);

    return null;
}
